import { render, staticRenderFns } from "./TopupDetail.vue?vue&type=template&id=2b3c5ad3&scoped=true&"
import script from "./TopupDetail.vue?vue&type=script&lang=js&"
export * from "./TopupDetail.vue?vue&type=script&lang=js&"
import style0 from "./TopupDetail.vue?vue&type=style&index=0&id=2b3c5ad3&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b3c5ad3",
  null
  
)

export default component.exports